import { ArticleModel } from "../archive/article.model";
import { MeterModel } from "./meter.model";

export class MeterDetailModel {
    meterDetailId: number = 0;
    meterId: number = 0;
    meter: MeterModel | null = null;
    articleId: number = 0;
    article: ArticleModel | null = null;
    dateMeterDetail: Date = new Date();
    isResetHourMeter: boolean = false;
    quantity: number = 0;
    captureQuantity: number = 0;
    createDate: Date = new Date();
    userNameCreate: string = '';
    updateDate: Date | null = null;
    userNameUpdate: string | null = null;
}